import React, {useEffect, useState} from 'react';
import Config from '../../../../../Config';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {stageEnums} from '../../Assets/VolteCheckVariables';
import {isMobile} from 'react-device-detect';

const NotSupportedScreen = (props) => {
  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע המעודכן והאמין <br />
      ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת <br />
      לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );
  return (
    <div className='notSupportedStage'>
      <div className='headBox'>
        <p className='heading'>
          אנחנו מזהים שהמכשיר {isMobile ? <br /> : null}
          שלך לא תומך <br />
          ביכולת דור 4
        </p>
        <p className='subHeading'>
          כדי להמשיך ליהנות משירותי גלישה ושיחה, <br />
          מומלץ להחליף למכשיר תומך
        </p>
      </div>

      {props.iContent.supportedDevicesLink?.value && props.iContent.supportedDevicesText?.value && (
        <a
          href='#'
          className='supportLink'
          onClick={() => {
            buildUrlAndOpenSameWindow(props.iContent.supportedDevicesLink.value);
          }}>
          {props.iContent.supportedDevicesText?.value}{' '}
        </a>
      )}
      <div className='finishFooter'>
        <div className='headBox' style={{marginBottom: '12px'}}>
          <p className='subHeading' style={{marginBottom: '0px'}}>
            מתלבטים מה לבחור? נציג שלנו ישמח לעזור!{' '}
          </p>
        </div>
        {props.data.sentCallback ? (
          <div className='headBox' style={{marginTop: '12px'}}>
            <p className='subHeading' style={{marginBottom: '0px'}}>
              נציגינו יחזרו אליכם בהקדם{' '}
            </p>
          </div>
        ) : (
          <BtnSubmit
            className='mb-40'
            text='שנציג יחזור אליי'
            onclick={() => {
              props.setStage(stageEnums.callback);
            }}
          />
        )}
        {disclaimerText}
      </div>
    </div>
  );
};

export default NotSupportedScreen;
